import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import type { GetEmPairedIcpsQuery } from '@uigy/generated/graphql';
import { AppInitializationService } from '@uigy/shared/services/app-initialization.service';
import { IemService } from '@uigy/shared/services/iem.service';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class IemPairedIcpsGuard implements CanActivate {
  constructor(private iemService: IemService,
              private appInitializationService: AppInitializationService

  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {

    return this.appInitializationService.appInitialized.pipe(
      filter(isInitialized => isInitialized),
      switchMap(() => this.iemService.getIsEm()),
      switchMap(isEm => {
        if (!isEm) {
          return of(true);
        }
        return this.iemService.getIemDetails().pipe(
          map((data: GetEmPairedIcpsQuery['emPairedIcps']) => {
            this.iemService.iemPairedIcps = data;
            return true;
          }),
          catchError((err) => {
            console.error('Failed to load iem details', err);
            return of(false);
          }),
        );
      }),
      catchError((err) => {
        console.error('Failed to determine EM status', err);
        return of(false);
      }),
    );
  }
}
